/**
 * 车辆评估申请信息详细
 */

import React, { Component } from 'react';
import { Modal, Button, Descriptions,Divider} from 'antd';
import {EchartLine} from './EchartLine'
import {EchartBar} from './EchartBar'

const basic = [{
    "text": "品牌",
    "field": "vehicleBrandName",
}, {
    "text": "车系",
    "field": "vehicleFamilyName",
}, {
    "text": "款式",
    "field": "vehicleVersionName",
}, {
    "text": "卖车时间",
    "field": "sellExpect",
},
//  {
//     "text": "车主名称",
//     "field": "ownerName",
// },
 {
    "text": "车主电话",
    "field": "ownerTel",
},
 {
    "text": "上牌日期",
    "field": "plateDate",
}, {
    "text": "表显里程/万公里",
    "field": "mileage",
}, 
//  {
//     "text": "预约精准估价",
//     "field": "hasAppointment",
//     format: { 0: '否', 1: '是' }
// }, 
// {
//     "text": "预约的店",
//     "field": "shopName",
// },
 {
    "text": "最早开始时间",
    "field": "appointmentStartTime",
}, {
    "text": "最晚到店时间",
    "field": "appointmentEndTime",

}];
const  price = [{
    "text": "新车指导价",
    "field": "newCarGuidePrice",
}, {
    "text": "本地新车价（含税）",
    "field": "newCarLocalPrice",
}, {
    "text": "车况优秀（最大估值）",
    "field": "goodMax",
}, {
    "text": "车况优秀（最小估值）",
    "field": "goodMin",
}, {
    "text": "车况良好（最大估值）",
    "field": "normalMax",
}, {
    "text": "车况良好（最小估值）",
    "field": "normalMin",
}, {
    "text": "车况一般（最大估值）",
    "field": "badMax",
}, {
    "text": "车况一般（最小估值）",
    "field": "badMin",
},]


class VehicleEvaluateDetail extends Component {
    state = {
        barData: {},
        LineData: {},
        editData:{}
    };

    componentDidMount(){
        this.props.initEdit(this.initEdit);
    }

    creaateDetail = (data) => {
        const { editData } = this.props;
        let dom = [];
        for (let i = 0; i < data.length; i ++) {
            let text = editData[data[i]["field"]];
            if(data[i]["format"] != null){
                text = data[i]["format"][text];
            }
            dom.push(<Descriptions.Item key={i} label={data[i]["text"]}>{text}</Descriptions.Item>);
        }
        return dom;
    }
    initEdit=(editData)=>{
        this.setState({
            editData:editData
        })
        if(editData.apiType ==='chaboshi'){
            this.getLineData();
            this.getBarData();
            this.state.initChart();
            this.state.initChartBar();
        }
       
    }
      // 线型数据
    getLineData = () => {
        let editData = this.state.editData;
        let date = [];
        let price = [];
        if(editData.datePriceJson!==null){
            if(editData.datePriceJson&&editData.datePriceJson.length!==0){
                for(let i=0;i<editData.datePriceJson.length;i++){
                    date.push(editData.datePriceJson[i].date)
                    price.push(editData.datePriceJson[i].price)
                }
            }
        }
        let getData = [
            {
                name: '保值率 ',
                type: 'line',
                data:  price,
                itemStyle: {
                    normal: {
                        color: '#0096f3'
                    }
                },
                areaStyle: {},
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
                
            }
        ];
        let optionData = {
            listData: getData,
            id: 'VehicleEvaluateLine',
            xSeries:date,
            areaStyle: {},
        };
        this.setState({ LineData: optionData });
    }

    getBarData= () => {
        let editData = this.state.editData;
        let cityName = [];
        let price = [];
        if(editData.cityPriceJson!==null){
            if(editData.cityPriceJson.length!==0){
                for(let i=0;i<editData.cityPriceJson.length;i++){
                    cityName.push(editData.cityPriceJson[i].cityName)
                    price.push(editData.cityPriceJson[i].price)
                }
            }
        }
       
        let getData = [
            {
                name: '价格排行',
                type: 'bar',
                data: price,
                itemStyle: {
                    normal: {
                        color: '#0096f3'
                    }
                },
                areaStyle: {},
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
                barWidth : 20,//柱图宽度
                
            }
        ];
        let optionData = {
            listData: getData,
            id: 'VehicleEvaluateBar',
            xSeries:cityName,
            areaStyle: {},
        };
        this.setState({ barData: optionData });
    }

    render() {
        const { visible, onCancel,editData} = this.props;
        return (
            <Modal
                width={1200}
                visible={visible}
                title="车辆评估详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                footer={[
                    <Button key="cancel" type="default" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Divider orientation="left">基本信息</Divider>
                <Descriptions bordered column={3}>
                   {this.creaateDetail(basic)}
                </Descriptions>

                <Divider orientation="left">预估价格（万元）</Divider>
                <Descriptions bordered column={2}>
                   {this.creaateDetail(price)}
                </Descriptions>
                <div style={{width:'100%',marginTop:'40px',overflow:'hidden'}}>
                    {
                        editData.datePriceJson!==null?
                            <div style={{ width:'50%', height: '400px',float:'left' }}>
                                <EchartLine
                                echartId={this.state.LineData.id}
                                title={'保值率'} 
                                echartData={this.state.LineData} 
                                initChart={(func) => { this.setState({ initChart: func }) }}
                                />
                            </div>
                            :''
                    }
                   {
                        editData.cityPriceJson!==null?
                        <div style={{ width:'50%', height: '400px' ,float:'left'}}>
                            <EchartBar
                            echartId={this.state.barData.id}
                            title={'全国车型价格排行'} 
                            echartData={this.state.barData}
                            initChart={(func) => { this.setState({ initChartBar: func }) }}
                            />
                        </div>
                        :''
                   }
                   
                </div>
            </Modal>
        );
    }
}


export default VehicleEvaluateDetail;